import Icon from '../components/Icon.vue'

Icon.register({
  'user-edit': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M224 256c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128-57.3 128-128 128zM313.6 288c39.9 0 75.4 17.8 99.9 45.5l-77.3 77.3-7.9 7.9-1.2 11.1-6.8 60.9c-0.8 7.3 0.2 14.5 2.6 21.3h-274.9c-26.5 0-48-21.5-48-48v-41.6c0-74.2 60.2-134.4 134.4-134.4h16.7c22.3 10.2 46.9 16 72.9 16s50.7-5.8 72.9-16h16.7zM358.9 433.3l137.9-137.8 71.7 71.7-137.9 137.9-60.9 6.8c-10.1 1.2-18.7-7.4-17.6-17.6zM633 268.9c9.3 9.4 9.3 24.5 0 33.9l-41.8 41.8-71.8-71.7 4.1-4.1 37.8-37.8c9.3-9.3 24.5-9.3 33.8 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-edit.js
// module id = 2063
// module chunks = 0